/**
 * WARNING: This component is auto-generated by the build script in the parent directory.
 * Do not edit this file, as any changes will be overwritten. Instead, edit the template and
 * svg files to make changes
 */
import React from "react";
import classNames from "classnames";
import { IIconProps, IconSize } from "../types";

const Loom = (props: IIconProps): React.ReactElement => {
  const { className, size = IconSize.Medium, ...rest } = props;
  const iconClass = classNames("kl-icon", `kl-icon--${size}`, className);
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    <path
      fillRule="evenodd"
      d="M12 4a5 5 0 00-4 8 7 7 0 017-7 4.979 4.979 0 00-3-1zm0 10a4.992 4.992 0 01-1.703-.297A4.99 4.99 0 0110 12c0-.598.105-1.171.297-1.703A4.99 4.99 0 0112 10c.598 0 1.171.105 1.703.297.192.53.297 1.104.297 1.703 0 .598-.105 1.171-.297 1.703A4.989 4.989 0 0112 14zm0 2a7 7 0 01-7-7 5 5 0 007 7zM5.782 5.782A7 7 0 0112 2a7 7 0 016.218 3.782A7 7 0 0122 12a7 7 0 01-3.782 6.218A7 7 0 0112 22a7 7 0 01-6.218-3.782A7 7 0 012 12a7 7 0 013.782-6.218zM8.999 19a5 5 0 007-7h.001a7 7 0 01-7 7zm3-11a5 5 0 017 7 7 7 0 00-6.999-7z"
      clipRule="evenodd"
    />,
  );
};

export default Loom;
